<div class="products-container">
  <h2>Products</h2>

  <!-- ── Pending Inventory Section ── -->
  <app-pending-inventory></app-pending-inventory>
  <!-- ── End Pending Inventory Section ── -->

  <div class="actions-section">
    <button mat-raised-button class="create-btn" (click)="createNewProduct()">
      <mat-icon>add</mat-icon>
      Create New Product
    </button>
  </div>

  <div class="products-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading products...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadProducts()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search products</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by name, catalog #, lot #..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Products Table -->
      <table mat-table [dataSource]="dataSource" matSort class="products-table">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
          <td mat-cell *matCellDef="let product">{{ product.name || 'Unnamed' }}</td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let product">{{ product.description || '-' }}</td>
        </ng-container>

        <!-- Catalog Number Column -->
        <ng-container matColumnDef="catalogNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Catalog #</th>
          <td mat-cell *matCellDef="let product">{{ product.catalogNum || '-' }}</td>
        </ng-container>

        <!-- Lot Number Column -->
        <ng-container matColumnDef="lotNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Lot #</th>
          <td mat-cell *matCellDef="let product">{{ product.lotNum || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editProduct(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-products">
              <mat-icon>inventory_2</mat-icon>
              <p *ngIf="!input.value">No products found. Click "Create New Product" to add your first product.</p>
              <p *ngIf="input.value">No products match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator 
        [pageSizeOptions]="[5, 10, 25, 50]" 
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of products">
      </mat-paginator>
    </div>
  </div>
</div>
